import { spell } from 'helpers/international_spelling'

angular.module('filters').filter 'spell', ($rootScope) ->
  (key, country) ->
    resolvedCountry = country or $rootScope?.gym?.country
    spell(key, resolvedCountry)
